'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = termsConditions;

var _ajaxHelper = require('../libraries/ajaxHelper');

var _ajaxHelper2 = _interopRequireDefault(_ajaxHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function termsConditions() {
    var selectorBase = '.terms-conditions .file-input-wrapper';
    var fileIdElement = document.querySelector(selectorBase + ' #FileId');
    if (!fileIdElement) return;

    var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
                getFileName();
                $('#FileDlg').modal('hide');
            }
        });
    });

    observer.observe(fileIdElement, { attributes: true });

    function getFileName() {
        if (fileIdElement.dataset.tempId === fileIdElement.value) {
            return;
        }
        fileIdElement.dataset.tempId = fileIdElement.value;
        var ajaxHelper = new _ajaxHelper2.default();
        ajaxHelper.sendRequest('/TermCondition/GetFileDetail', function (httpRequest, rspObj) {
            var fileNameElement = document.querySelector(selectorBase + ' #FileName');
            if (fileNameElement && rspObj.result.success) {
                fileNameElement.value = JSON.parse(rspObj.result.detail).Name;
            }
        }, { id: fileIdElement.value });
    }
}


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/Initializers/termsConditions.js
// module id = 412
// module chunks = 0